import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  Create,
  SimpleForm,
  TextInput,
  Edit,
  EditButton,
  Delete,
  Filter,
  ReferenceInput,
  SelectInput,
  required
} from 'admin-on-rest/lib/mui';

import { Actions } from '../custom/actions';

export const UserFilter = (props) => (
  <Filter {...props}>
  <TextInput label="resources.name.name" source="name" alwaysOn/>
  <TextInput label="resources.surname.name" source="surname" alwaysOn/>
  <TextInput label="email" source="email" alwaysOn/>
  </Filter>
);

export const UserList = (props) => (
    <List title="resources.management_users.name" actions={<Actions />} filters={<UserFilter />} {...props}>
        <Datagrid>
          <TextField label="resources.name.name" source="name" />
          <TextField label="resources.surname.name" source="surname" />
          <EmailField source="email" />
          <EditButton />
        </Datagrid>
    </List>
);

export const CreateUser = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput label="resources.name.name" source="name" validate={required} />
      <TextInput label="resources.surname.name" source="surname" validate={required} />
      <TextInput label="resources.password.name" source="password" validate={required} />
      <TextInput source="email" validate={required} />
      <ReferenceInput label="resources.companies.name" source="CompanyID" reference="companies" allowEmpty validate={required}>
      <SelectInput optionText={choice => `${choice.name}`} />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

const PostTitle = ({ record }) => {
    return <span>{record ? `${record.name}` : ''}</span>;
};


export const EditUser = (props) => (
  <Edit title={<PostTitle />} {...props}>
    <SimpleForm>
    <TextInput source="name" label="resources.name.name" />
    <TextInput source="surname" label="resources.surname.name" />
    <TextInput source="email" />
    <ReferenceInput label="resources.companies.name" source="CompanyID" reference="companies" allowEmpty>
    <SelectInput optionText={choice => `${choice.name}`} />
    </ReferenceInput>
    </SimpleForm>
  </Edit>
);

export const DeleteUser = (props) => <Delete {...props} />;



// WEBPACK FOOTER //
// ./src/pages/users.js